import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateOrganisationSettings } from '@api/organisationSettings';

import { IUpdateOrganisationSettingsDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATION_SETTINGS, UPDATE_ORGANISATION_SETTINGS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateUpdateOrganisationSettingsReturnInterface {
	handleUpdateOrganisationSettings: (data: IUpdateOrganisationSettingsDTO) => void;
	isLoadingUpdateOrganisationSettings: boolean;
}

export const useMutateUpdateOrganisationSettings = (): IUseMutateUpdateOrganisationSettingsReturnInterface => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateOrganisationSettings,
		isLoading: isLoadingUpdateOrganisationSettings,
	} = useMutation<IUpdateOrganisationSettingsDTO>({
		mutationKey: [UPDATE_ORGANISATION_SETTINGS],
		mutationFn: updateOrganisationSettings,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedOrganisationSettings,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([ORGANISATION_SETTINGS])];
		},
	});

	return {
		handleUpdateOrganisationSettings,
		isLoadingUpdateOrganisationSettings,
	};
};
